/**
 * Created by spepa on 09.09.2024
 */

const GameSnackLogic = function () {
    PlatformLogic.call(this);
};

GameSnackLogic.prototype = Object.create(PlatformLogic.prototype);
GameSnackLogic.prototype.constructor = GameSnackLogic;

GameSnackLogic.prototype.onStart = function () {
    if (cleverapps.user.isFirstSession()) { // reset corrupted data
        cleverapps.dataLoader.save(DataLoader.TYPES.COMPETITION_PLAYERS, null);

        Object.keys(Missions).forEach((missionType) => {
            const missionData = Missions[missionType];
            if (missionData && missionData.competition) {
                cleverapps.dataLoader.save(`${DataLoader.TYPES.COMPETITION}_${missionType}`, null);
            }
        });
    }
};

GameSnackLogic.prototype.reportScore = function (score, callback) {
    if (["merge", "merge2"].includes(cleverapps.config.type)) {
        return;
    }
    GameSnacks.score.update(score);
    callback(cleverapps.CODE_SUCCEED);
};

GameSnackLogic.prototype.reportLevelUp = function () {
    const value = levels.user.getVirtualLevel() - 1;
    GameSnacks.game.levelComplete(value);
};

GameSnackLogic.prototype.reportGameOver = function () {
    GameSnacks.game.gameOver();
};